import React from "react";
import { Route, Switch } from "react-router-dom";
import { routerPath } from "@config";
import { SuccessApproveContainer, ApplicationKYCSmeContainer } from "@containers";
import { Content404 } from "@components";

export const MainSmeContainer = () => {
  return (
    <>
      <Switch>
        <Route exact path={routerPath.kyc} component={ApplicationKYCSmeContainer} />
        <Route exact path={routerPath.successApprove} component={SuccessApproveContainer} />
        <Route component={Content404} />
      </Switch>
    </>
  );
};
